import { useState, useRef } from "react"

import Style from "./style"
import Wrapper from "../Wrapper"

import useGetAdvertiseList from "entity/advertiseTimer/useGetAdvertiseList"

import useThemeCookie from "shared/model/useThemeCookie"
import { useEffect } from "react"

const NormalBreak = ({ countDown, timeData, infoData, logoImg, eventName, uploadImage, loading, eventData, navigationBlock, setNavigationBlock, navigateWithConfirm }) => {
    const [themeCookie] = useThemeCookie()

    const [adList] = useGetAdvertiseList()

    const [currentIndex, setCurrentIndex] = useState(0)   // 화면 전환용 state 변수
    const [videoErrorMsg, setVideoErrorMsg] = useState("")   // 비디오 에러 상세 메세지
    const DEBUG_FORCE_ERROR = 0; // 에러 테스트값 (0: 끄기, 1: 네트워크 에러, 2: 형식 오류, 3: 시스템 제한, 4: 타임아웃)

    const [isVideoLoading, setIsVideoLoading] = useState(true) // 비디오 로딩 중 상태
    const [timeoutCountdown, setTimeoutCountdown] = useState(DEBUG_FORCE_ERROR === 4 ? 3 : null) // 타임아웃 카운트다운

    let displayErrorMsg = videoErrorMsg;
    if (DEBUG_FORCE_ERROR === 1) displayErrorMsg = "네트워크 오류로 인해 광고를 로드하지 못했습니다."; // The advertisement cannot be loaded due to network errors.
    else if (DEBUG_FORCE_ERROR === 2) displayErrorMsg = "지원되지 않는 광고 형식이거나 링크가 손상되었습니다."; // The advertisement cannot be loaded because the format is not supported or the link is damaged.
    else if (DEBUG_FORCE_ERROR === 3) displayErrorMsg = "메모리 부족으로 인해 광고를 로드할 수 없습니다."; // The advertisement cannot be loaded due to memory shortage.
    else if (DEBUG_FORCE_ERROR === 4) displayErrorMsg = "광고 연결 시간이 초과되었습니다."; // The advertisement connection time has exceeded the limit.

    // 아래 ref들은 tick에서 사용하기 위한 closure 변수임
    const currentIndexRef = useRef()   // 현재 출력중인 광고 index
    const lastUpdateRef = useRef()   // 광고가 전환되었을 때의 시점
    const checkRunningRef = useRef()   // 현재 tick이 구동 중인지 체크
    const videoErrorRef = useRef(false) // tick 내에서 비디오 에러 상태 확인용
    const isVideoPlayingRef = useRef(false) // 비디오가 실제로 재생을 시작했는지 확인용
    const loadTimeoutRef = useRef(null) // timeout 아이디 보관용

    const resetLoadTimeout = () => {
        if (loadTimeoutRef.current) clearTimeout(loadTimeoutRef.current);
        
        loadTimeoutRef.current = setTimeout(() => {
            if (!isVideoPlayingRef.current) {
                console.warn(`Video hung on network or decoding. Reloading page.`);
                setVideoErrorMsg("광고 연결 시간이 초과되었습니다.")
                videoErrorRef.current = true
                setTimeoutCountdown(3)
            }
        }, 60000); // Wait strictly 60s from last activity gap
    }

    useEffect(() => {
        setVideoErrorMsg("")
        videoErrorRef.current = false
        isVideoPlayingRef.current = false
        setIsVideoLoading(true)

        const currentItem = adList?.data?.advertise_timer_list?.[currentIndex];
        
        if (currentItem && currentItem.type !== "image") {
            resetLoadTimeout()
        }

        return () => {
            if (loadTimeoutRef.current) clearTimeout(loadTimeoutRef.current);
        }
    }, [currentIndex, adList])

    useEffect(() => {
        if (timeoutCountdown === null) return;
        
        if (timeoutCountdown === 0) {
            window.location.reload();
            return;
        }

        const timer = setTimeout(() => {
            setTimeoutCountdown(prev => prev - 1);
        }, 1000);

        return () => clearTimeout(timer);
    }, [timeoutCountdown])

    const makeTick = (srcList) => {

        return () => {
            if (!checkRunningRef.current) return   // 재귀로 실행된 animationFrame 해제용

            const nowIndex = currentIndexRef.current

            if (srcList[nowIndex]?.type === "image" || videoErrorRef.current) {
                const now = Date.now()
                const elapsed = now - lastUpdateRef.current

                if (elapsed >= 10000) {   // 진행 시간이 10초보다 크다면
                    videoErrorRef.current = false
                    setCurrentIndex((nowIndex + 1) % srcList?.length)   // 끝 파일에 돌아가면 0으로 돌아갈 수 있게 작성된 수식
                    currentIndexRef.current = (nowIndex + 1) % srcList?.length
                    lastUpdateRef.current = now
                }

                requestAnimationFrame(makeTick(srcList))   // animcation frame 재귀 실행
            }
        }
    }

    // 광고 자동 전환 모듈
    useEffect(() => {
        if (!adList) return   // 백엔드 통신이 아직이라면 실행 안함

        // tick 구동을 위한 값들 초기화
        checkRunningRef.current = true
        lastUpdateRef.current = Date.now()
        currentIndexRef.current = 0

        // animcation frame 구동 ( tick 삽입 )
        const anima = requestAnimationFrame(makeTick(adList?.data?.advertise_timer_list))   // requestAnimationFrame가 뭔지 모르면 찾아볼 것

        return () => {
            checkRunningRef.current = false   // 이렇게 해줘야만 재귀로 실행된 animation frame들이 같이 종료됨
            cancelAnimationFrame(anima)
        }
    }, [adList])

    return (
        <Wrapper title={eventName} infoData={infoData} logoImg={logoImg} timeData={timeData}
        countDown={countDown} eventData={eventData} navigationBlock={navigationBlock} setNavigationBlock={setNavigationBlock} navigateWithConfirm={navigateWithConfirm}>
            <Style.AdDiv $themeType={themeCookie}>
                <Style.SrcDiv>
                    {(!adList || (adList?.data?.advertise_timer_list?.[currentIndex]?.type === "video" && isVideoLoading && !displayErrorMsg)) && (
                        <Style.LoadingContainer $themeType={themeCookie}>
                            <Style.Loader $themeType={themeCookie} />
                        </Style.LoadingContainer>
                    )}
                    {adList?.data?.advertise_timer_list?.length < 1
                        ? <p>출력할 광고가 없습니다.</p>
                        : adList?.data?.advertise_timer_list[currentIndex]?.type === "image"
                            ? <img alt='alt' src={adList?.data?.advertise_timer_list[currentIndex]?.src} />
                            : displayErrorMsg 
                                ? (
                                    <Style.FallbackWarning $themeType={themeCookie}>
                                        <svg viewBox="0 0 24 24">
                                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
                                        </svg>
                                        <p>{displayErrorMsg}</p>
                                        {(timeoutCountdown !== null) && (
                                            <p style={{fontSize: "24px", marginTop: "-10px"}}>{timeoutCountdown}초 후 자동으로 새로고침됩니다.</p>
                                        )}
                                    </Style.FallbackWarning>
                                )
                                : <video src={adList?.data?.advertise_timer_list[currentIndex]?.src} muted playsInline autoPlay
                                onProgress={() => {
                                    // Heavy chunks downloading: reset timeout deadline seamlessly!
                                    if (!isVideoPlayingRef.current) resetLoadTimeout();
                                }}
                                onPlaying={() => {
                                    isVideoPlayingRef.current = true;
                                    setIsVideoLoading(false);
                                    if (loadTimeoutRef.current) clearTimeout(loadTimeoutRef.current);
                                }}
                                onError={(e) => {
                                    const errorCode = e.target.error?.code;
                                    let msg = "광고를 로드할 수 없습니다.";
                                    if (errorCode === 2) msg = "네트워크 오류로 인해 광고를 로드하지 못했습니다.";
                                    else if (errorCode === 3) msg = "메모리 부족으로 인해 광고를 로드할 수 없습니다.";
                                    else if (errorCode === 4) msg = "지원되지 않는 광고 형식이거나 링크가 손상되었습니다.";
                                    
                                    console.error("Video error caught:", e.target.error)
                                    setVideoErrorMsg(msg)
                                    videoErrorRef.current = true
                                    const now = Date.now()
                                    const srcList = adList?.data?.advertise_timer_list
                                    lastUpdateRef.current = now
                                    if (checkRunningRef.current) {
                                        requestAnimationFrame(makeTick(srcList))
                                    }
                                }}
                                onEnded={() => {
                                    const now = Date.now()
                                    const srcList = adList?.data?.advertise_timer_list
                                    const nowIndex = currentIndexRef.current
                                    const nextIndex = (nowIndex + 1) % srcList?.length

                                    setCurrentIndex(nextIndex)   // 끝 파일에 돌아가면 0으로 돌아갈 수 있게 구현
                                    currentIndexRef.current = nextIndex   // Ticket에서 참조하기 위한 index 업데이트
                                    lastUpdateRef.current = now   // 마지막 반영 시간 업데이트

                                    if (srcList[nextIndex]?.type === "image" && checkRunningRef.current) {
                                        requestAnimationFrame(makeTick(srcList))
                                    }
                                }}
                                loop={adList?.data?.advertise_timer_list?.length > 1 ? false : true}
                            />
                    }
                </Style.SrcDiv>
            </Style.AdDiv>

        </Wrapper >
    )
}

export default NormalBreak
